import {
	lifHttp as http,
	vcpodeHttp as httpVcpode,
	vcpodeBearer,
} from "@/http";
import { downloadBeneficiaryImportTemplate } from "@/utils/beneficiaryImport";
import { cnpj, cpf } from "cpf-cnpj-validator";
import { serialize } from "./utils";
import { viacep } from './viacep';

// lifHttp endpoints
const getFaq = (data) => http.get(`faq?limit=${data.limit}&offset=${data.offset}`);
const createFaq = (data) => http.post(`faq/`, data);
const updateFaq = (payload, data) => http.put(`faq/${payload}`, data);

const getPagesApp = (data) => http.get(`page?limit=${data.limit}&offset=${data.offset}`);
const createPagesApp = (data) => http.post(`page/`, data);
const updatePagesApp = (payload, data) => http.put(`page/${payload}`, data);
const updateImagePagesApp = (payload) => http.put(`page/${payload}/image`);

const getBanners = async (data = {}) => {
	const params = serialize({ ...data });
	return http.get(`banner${params}`);
}
const createBanner = (data) => http.post(`banner/`, data);
const updateBanner = (payload, data) => http.put(`banner/${payload}`, data);
const updateImageBanner = (payload) => http.put(`banner/${payload}/image`);

const getCoupons = async (data = {}) => {
	const params = serialize({ ...data });
	return http.get(`cupom${params}`);
}
const createCoupon = (data) => http.post(`cupom/`, data);
const updateCoupon = (payload, data) => http.put(`cupom/${payload}`, data);

const getPlans = async (data) => {
	const params = serialize({ ...data });
	return http.get(`product${params}`);
}
const getPlansByPartner = async (payload) => http.get(`product?partner=${payload}`)
const updatePlan = (payload, data) => http.put(`product/${payload}`, data);
const createPlan = (data) => http.post(`product/`, data);

const getAllPartners = (data) => http.get(`partner?limit=${data.limit}&offset=${data.offset}`);
const getPartnersUsers = async (data = {}) => {
	const params = serialize({ ...data });
	return http.get(`user/all${params}`);
}
const createPartner = (data) => http.post(`partner/`, data);
const updatePartner = (payload, data) => http.put(`partner/${payload}`, data);
const makeIndividualOrder = async (data) => http.post(`partner/order`, data);

const getUsers = (data) => http.get(`user/all?limit=${data.limit}&offset=${data.offset}`);
const getOrdersUsers = (data = {}) => {
	const params = serialize({ ...data });
	return http.get(`orders/adm${params}`);
}

const desactivateClient = (data) => http.delete(`order/${data.id}?cancel_reason=${data.cancel_reason}`);
const desactivateClientBankMaster = (payload) => http.post(`cancel-order-bank-master/${payload}`);
const reactivateClient = (payload) => http.put(`sales/reactivate/${payload}`);

const exists = async (data) => http.post(`exists`, data)

const getUserByDocument = (data) => http.get(`orders/adm?document=${data.document}&status=${data.status}&isCompany=${data.isCompany}`);

const inactivateCompany = async (companyId) => http.delete(`/company/${companyId}/inactivate`);
const reactivateCompany = async (companyId) => http.put(`/company/${companyId}/reactivate`);

const deleteDependent = async (data) => http.delete(`/order/${data.orderId}/deps/${data.dependentId}`);

const getCurrentUser = () => http.get('user');
const addDependent = async (data) => http.post(`user`, data);
const internalAddDependent = async (data) => http.post(`user/internal`, data);
const updateUser = async (payload, data) => http.put(`user/${payload}`, data);
const updateOrder = async (data) => http.put(`order/${data.id}/deps`, data);

const sendNewPassword = async (data) => http.post("email/password/new", data);
const getCEP = (zipCode) => viacep.getCEP(zipCode);

const getSacUsers = async (data) => http.get(`conversations/users?limit=${data.limit}&offset=${data.offset}`);
const createSacUsers = async (data) => http.post(`conversations/users`, data);
const updateStatusSacUsers = async (data) => http.put(`conversations/users/status/${data.id}?status=${data.status}`);

const downloadFileModel = async () => downloadBeneficiaryImportTemplate();
const getTemplates = async () => {
	const credentials = btoa(`${process.env.VUE_APP_ACCOUNT_SID}:${process.env.VUE_APP_AUTH_TOKEN}`);
	const res = await fetch(
		"https://content.twilio.com/v2/ContentAndApprovals?ChannelEligibility=whatsapp:approved&Language=pt_BR&PageSize=100&Page=0",
		{ headers: { Authorization: `Basic ${credentials}` } }
	);
	const data = await res.json();
	return { data };
};
const sendTemplateMessage = async (data) => http.post(`notifications/message/whatsapp`, data);

// vcpodeHttp endpoints
const getCompanies = async (data = {}) => {
	const params = {
		status: data.status || 'ativo',
		limit: data.limit,
		offset: data.offset
	};

	if (data.search) {
		if (cpf.isValid(data.search) || cnpj.isValid(data.search)) {
			params.document = cnpj.format(data.search);
		} else {
			params.name = data.search;
		}
	}

	return httpVcpode.get(`v2/company${serialize(params)}`);
};

const getBeneficiariesByCompany = async (companyId, data = {}) => {
	const params = serialize({ ...data });
	return httpVcpode.get(`v2/company/${companyId}/titular${params}`);
}

const makeCompanyOrder = async (data) => httpVcpode.post(`v2/company`, data);
const addResponsibleToCompany = async (companyId, data) => httpVcpode.post(`v2/company/${companyId}/responsible`, data);
const addPlanWithCompany = async (companyId, data) => httpVcpode.post(`v2/company/${companyId}/plan`, data);
const addBeneficiary = async (companyId, data) => httpVcpode.post(`v2/company/${companyId}/titular`, data);

const addDependentToBeneficiary = async (beneficiaryId, data) => httpVcpode.put(`v2/company/order/${beneficiaryId}/dependents`, data);
const updateCompany = async (companyId, data) => httpVcpode.put(`v2/company/${companyId}/update`, data);

const removePlanFromCompany = async (companyId, planId) => httpVcpode.delete(`v2/company/${companyId}/plan/${planId}`);
const removeBeneficiaryToCompany = async (data) => httpVcpode.delete(`v2/company/${data.companyId}/titular/${data.beneficiaryId}`);

const sendPushNotification = async (data) => vcpodeBearer.post(`notifications/push/send`, data);
const deleteDependentByCompany = async (data) => httpVcpode.delete(`/order/${data.orderId}/deps/${data.dependentId}`);

// Não implementadas
const getCompanyById = async (companyId) => httpVcpode.get(`v2/company/${companyId}`);
const updateCompanyPlan = async (planId, data) => httpVcpode.put(`v2/company/plan/${planId}`, data);
const updatePlansWithCompany = async (companyId, data) => httpVcpode.put(`v2/company/${companyId}/plan`, data);
const updateBeneficiary = async (beneficiaryId, data) => httpVcpode.put(`v2/company/titular/${beneficiaryId}`, data);
const updateDependent = async (dependentId, data) => httpVcpode.put(`v2/company/dependent/${dependentId}`, data);
const deleteResponsible = async (companyId, responsibleId, data) => httpVcpode.delete(`v2/company/${companyId}/responsible/${responsibleId}`, data);

export const offers = {
	getFaq,
	createFaq,
	updateFaq,

	getPagesApp,
	createPagesApp,
	updatePagesApp,
	updateImagePagesApp,

	getBanners,
	createBanner,
	updateBanner,
	updateImageBanner,

	getCoupons,
	createCoupon,
	updateCoupon,

	getPlans,
	getPlansByPartner,
	updatePlan,
	createPlan,

	getAllPartners,
	createPartner,
	updatePartner,

	getUsers,
	getOrdersUsers,
	desactivateClient,
	desactivateClientBankMaster,
	reactivateClient,

	getUserByDocument,
	getCurrentUser,
	getBeneficiariesByCompany,

	exists,

	makeCompanyOrder,
	getCompanies,
	updateCompany,
	addPlanWithCompany,
	removePlanFromCompany,
	addBeneficiary,
	addDependentToBeneficiary,
	inactivateCompany,
	reactivateCompany,
	addResponsibleToCompany,
	removeBeneficiaryToCompany,
	deleteDependent,

	makeIndividualOrder,

	updateUser,
	updateOrder,
	addDependent,
	internalAddDependent,
	sendNewPassword,

	getCEP,

	getSacUsers,
	createSacUsers,
	updateStatusSacUsers,

	downloadFileModel,

	getTemplates,
	sendTemplateMessage,
	sendPushNotification,

	getCompanyById,
	updateCompanyPlan,
	updateBeneficiary,
	updateDependent,
	deleteResponsible,
	updatePlansWithCompany,
	getPartnersUsers,
	deleteDependentByCompany,
};
